import styled from 'styled-components'
import { Container, Box } from '../../atoms'

// Re-export shared filter styles from UI library
export {
  SectionAnalysisFilterSection as FilterSection,
  SectionAnalysisFilterBar as FilterBar,
  SectionAnalysisLocationFilters as LocationFilters,
  SectionAnalysisFilterChip as FilterChip,
  SectionAnalysisLocationBadge as LocationBadge,
  SectionAnalysisDivider as Divider,
  SectionAnalysisAdvancedFiltersToggle as AdvancedFiltersToggle,
  SectionAnalysisAdvancedFiltersPanel as AdvancedFiltersPanel,
  SectionAnalysisAdvancedFiltersHeader as AdvancedFiltersHeader,
  SectionAnalysisAdvancedFilters as AdvancedFilters,
} from '../../molecules/SectionAnalysisStyles/SectionAnalysisStyles'

export const StatsPageContainer = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 60px;
`

export const StatsContent = styled(Container)`
  max-width: 100%;
  padding: 0;
`

export const HeaderSection = styled(Box)`
  background: ${({ theme }) => theme.colors.background.primary};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.border.light || '#E5E7EB'};
`

export const FiltersRow = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  align-items: flex-start;
  flex-wrap: wrap;
`

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
  flex: 0 1 auto;
`

export const FilterLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.text.tertiary || '#9CA3AF'};
`

export const FilterSelectWrapper = styled.div`
  /* Override FilterSelect component styles */
  & > div {
    position: relative;
    width: 100%;

    select {
      width: 100%;
      padding: 10px 36px 10px 14px;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.text.primary || '#1F2937'};
      background: ${({ theme }) =>
        theme.colors.background.primary || '#FFFFFF'};
      border: 1.5px solid
        ${({ theme }) => theme.colors.border.light || '#E5E7EB'};
      border-radius: 8px;
      min-height: 44px;
      transition: all 0.2s ease;
      cursor: pointer;
      appearance: none;
      outline: none;

      &:hover {
        border-color: ${({ theme }) =>
          theme.colors.border.default || '#D1D5DB'};
        background: ${({ theme }) =>
          theme.colors.background.secondary || '#F9FAFB'};
      }

      &:focus {
        border-color: ${({ theme }) => theme.colors.primary || '#3B82F6'};
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        background: ${({ theme }) =>
          theme.colors.background.primary || '#FFFFFF'};
      }

      option {
        padding: 8px 12px;
        font-weight: normal;
      }
    }

    /* Style the arrow icon */
    & > div:last-child {
      pointer-events: none;

      svg {
        width: 16px;
        height: 16px;
        color: ${({ theme }) => theme.colors.text.tertiary || '#9CA3AF'};
      }
    }
  }
`

export const StickyHeader = styled(Box)`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.background.secondary};
  z-index: 3;
  padding-bottom: 0;
`

export const SectionsContainer = styled(Box)``

export const PlaceholderChart = styled.div`
  height: 400px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
`

export const LocationDisplay = styled.span`
  font-size: 14px;
  color: #6b7280;
`
